import React from "react"
import { Col, Row } from "reactstrap"
import styles from "./PricingCompetitiveness.module.scss"

const PricingCompetitiveness = () => {
  const leftColData = [
    { label: "Uncompetitive Products:", value: "50" },
    { label: "Estimated Orders Lost Daily:", value: "15" },
    { label: "Estimated Sales Lost Daily:", value: "$1000" },
  ]

  const rightColData = [
    { status: "Competitive", noOfProducts: "120", percentage: "60%" },
    { status: "Not Competitive", noOfProducts: "50", percentage: "25%" },
    { status: "Undetermined", noOfProducts: "30", percentage: "15%" },
  ]

  return (
    <section>
      <div className="fw-semibold fs-5 mb-3">Pricing Competitiveness</div>

      <Row className="gy-2 gy-lg-0">
        <Col xs='12' lg="4" className="flex-1 p-1 bg-white">
          <div className="border border-subtle-secondary h-100 d-flex flex-column justify-content-center">
            {leftColData.map((item) => (
              <Row className="g-0">
                <Col xs="8" className={`${styles.label} ps-3`}>
                  {item.label}
                </Col>
                <Col className={styles.value}>{item.value}</Col>
              </Row>
            ))}
          </div>
        </Col>
        <Col xs='12' lg="8" className="flex-1">
          <Row className={`${styles.header} g-0`}>
            <Col>Status</Col>
            <Col>Number of Products</Col>
            <Col>Percentage</Col>
          </Row>
          {rightColData.map((item) => (
            <Row className={`${styles.row} g-0`}>
              <Col>{item.status}</Col>
              <Col>{item.noOfProducts}</Col>
              <Col>{item.percentage}</Col>
            </Row>
          ))}
        </Col>
      </Row>
    </section>
  )
}

export default PricingCompetitiveness
